// A landscape phone (e.g. 926x428) is wide enough to clear the 768px
// "mobile" width breakpoint but only has ~400px of vertical room, so it
// must still be treated as mobile.
export const isMobileViewport = () =>
	window.innerWidth <= 768 || (window.innerWidth <= 932 && window.innerHeight <= 500);
